import CardCredentialOtpScreen from 'features/cardManagement/screens/cardCredentialChallenge/CardCredentialOtpScreen/CardCredentialOtpScreen';
import React from 'react';

export default function ProgressTrackerP2PCardCredentialOtpPage() {
  return (
    <CardCredentialOtpScreen returnPath="/progress-tracker-funding/p2p/debit" />
  );
}
